module.exports = __webpack_public_path__ + "static/media/display-icon-water.f921984d.png";